import { ReactComponent as Cancel } from './Cancel.svg';
import { ReactComponent as ArrowDown } from './CaretDown.svg';
import { ReactComponent as ArrowLeft } from './CaretLeft.svg';
import { ReactComponent as ArrowRight } from './CaretRight.svg';
import { ReactComponent as CheckMark } from './CheckMark.svg';
import { ReactComponent as GearSix } from './GearSixBackground.svg';
import { ReactComponent as Loader } from './Loader.svg';
import { ReactComponent as ShowMore } from './ShowMore.svg';
import { ReactComponent as SortDown } from './SortDown.svg';
import { ReactComponent as SortUp } from './SortUp.svg';
import { ReactComponent as Delete } from './Trash.svg';
import { ReactComponent as DeleteCircle } from './TrashCircle.svg';
import { ReactComponent as Wallet } from './Wallet-icon.svg';

export function CancelIcon() {
  return <Cancel />;
}

export function ArrowLeftIcon() {
  return <ArrowLeft />;
}

export function ArrowDownIcon() {
  return <ArrowDown />;
}

export function ArrowRightIcon() {
  return <ArrowRight />;
}

export function CheckMarkIcon() {
  return <CheckMark />;
}

export function DeleteIcon() {
  return <Delete />;
}

export function DeleteCircleIcon() {
  return <DeleteCircle />;
}

export function WalletIcon() {
  return <Wallet />;
}

export function SettingsBackgroundIcon() {
  return <GearSix />;
}

export function ShowMoreIcon() {
  return <ShowMore />;
}

export function LoaderIcon() {
  return <Loader />;
}

export function SortUpIcon() {
  return <SortUp />;
}

export function SortDownIcon() {
  return <SortDown />;
}
